import { NUDGE_WRITE, PLAYLIST_WRITE, USER_WRITE } from './constants';
import { hasPrivilege } from './hasPrivilege';
import config from 'utils/config';
import store from '../store';

/**
 * Can the user share content?
 * Given the current user's privileges, the hub settings, can the current user share content?
 * @returns {boolean} Whether the current user has permission to share content
 */
export function canUserShare() {
  if (hasPrivilege(USER_WRITE) || hasPrivilege(PLAYLIST_WRITE) || hasPrivilege(NUDGE_WRITE)) {
    return true;
  }
  var userToUserSharing = config.userToUserSharing,
    enableUserToUserSharing = config.enableUserToUserSharing;

  // If the enableUserToUserSharing is true and the userToUserSharing is false, then check if the user is a team member
  return enableUserToUserSharing && (userToUserSharing || store('isTeamMember'));
}